import { observable, action, computed, makeObservable } from 'mobx';

export type ViewDeviceV3 = 'SP' | 'TABLET' | 'DESKTOP';

const calculateViewDevice = (): ViewDeviceV3 => {
  if (window.matchMedia('(min-width: 1200px)').matches) {
    return 'DESKTOP';
  } else if (window.matchMedia('(min-width: 465px)').matches) {
    return 'TABLET';
  } else {
    return 'SP';
  }
};

export class ViewportStateV3 {
  viewDevice: ViewDeviceV3 = calculateViewDevice();

  constructor() {
    makeObservable(this, {
      viewDevice: observable,
      isMobile: computed,
      isDesktop: computed,
      isNonSp: computed,
      isSp: computed,
      update: action.bound,
    });
  }

  get isMobile() {
    return this.viewDevice === 'SP' || this.viewDevice === 'TABLET';
  }

  get isDesktop() {
    return this.viewDevice === 'DESKTOP';
  }

  get isNonSp() {
    return this.viewDevice !== 'SP';
  }

  get isSp() {
    return this.viewDevice === 'SP';
  }

  update() {
    this.viewDevice = calculateViewDevice();
  }
}
